import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireAdmin = false, allowMarcadorGeral = false, minRole = null }) => {
  const { user, loading, isAdmin, isMarcadorGeral, getRoleLevel } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-700 mx-auto"></div>
          <p className="mt-4 text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar nível mínimo de role
  if (minRole && getRoleLevel(user.role) < getRoleLevel(minRole)) {
    return <Navigate to="/" replace />;
  }

  // Se requer admin, verificar hierarquia
  if (requireAdmin && !isAdmin()) {
    if (allowMarcadorGeral && isMarcadorGeral()) {
      return children;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};